module.exports = __webpack_public_path__ + "img/logo-Sync2-Cloud.478c34c.png";